import classNames from 'classnames';
import React from 'react';
// import styles from './Icon.module.css';

type IconProps = {
  size?: number;
  'aria-label'?: string;
  color?: string;
  className?: string;
};

function createFontello(glyph: string): React.FC<IconProps> {
  return function Icon({ size = 2, 'aria-label': ariaLabel }) {
    const px = size !== 2 ? `${size * 8}px` : undefined;
    const textStroke = size === 1 ? '1px' : undefined;

    let className = ['icon'];

    // for multi-colored google icon
    if (glyph === '\uE840') {
      className = [...className, 'google'];
    }

    return (
      <span
        className={classNames(className)}
        style={{
          fontSize: px,
          width: px,
          height: px,
          WebkitTextStroke: textStroke,
        }}
        role="img"
        aria-label={ariaLabel}
        aria-hidden={ariaLabel ? undefined : 'true'}
      >
        {glyph}
      </span>
    );
  };
}

// Exported as individual components to facilitate tree shaking
export * from '@hyphengroup/cms-components/components/icons/whatsapIcon';
export const ActionsIcon = createFontello('\uE8A3');
export const AirMilesIcon = createFontello('\uE80C');
export const AmateurSportIcon = createFontello('\uE891');
export const ArrowDownIcon = createFontello('\uE8A4');
export const ArrowLeftIcon = createFontello('\uE8A5');
export const ArrowRightIcon = createFontello('\uE860');
export const ArrowUpIcon = createFontello('\uE8A6');
export const BatteryIcon = createFontello('\uE8A7');
export const BookmarkOutlinedIcon = createFontello('\uE8A8');
export const BookmarkSolidIcon = createFontello('\uE8A9');
export const BrokenPhoneIcon = createFontello('\uE89A');
export const BurglaryIcon = createFontello('\uE83F');
export const CalculatorIcon = createFontello('\uE81E');
export const CalendarIcon = createFontello('\uE8AA');
export const CalendarWithDatesIcon = createFontello('\uE892');
export const CarIcon = createFontello('\uE893');
export const CashIcon = createFontello('\uE839');
export const CashbackIcon = createFontello('\uE89B');
export const ChequeIcon = createFontello('\uE881');
export const ChevronDownIcon = createFontello('\uE84B');
export const ChevronLeftIcon = createFontello('\uE8AB');
export const ChevronRightIcon = createFontello('\uE8AC');
export const ChevronSmallDownIcon = createFontello('\uE868');
export const ChevronSmallLeftIcon = createFontello('\uE84D');
export const ChevronSmallRightIcon = createFontello('\uE870');
export const ChevronSmallUpIcon = createFontello('\uE826');
export const ChevronUpIcon = createFontello('\uE828');
export const CircleIcon = createFontello('\uE821');
export const ClaimIcon = createFontello('\uE85D');
export const ClappingIcon = createFontello('\uE80F');
export const ClockIcon = createFontello('\uE817');
export const CodingIcon = createFontello('\uE890');
export const CollectIcon = createFontello('\uE85B');
export const ConnectedIcon = createFontello('\uE819');
export const CopyLinkIcon = createFontello('\uE886');
export const CreditCardIcon = createFontello('\uE889');
export const CreditCardsIcon = createFontello('\uE89F');
export const CrossIcon = createFontello('\uE874');
export const CrossOutlinedIcon = createFontello('\uE850');
export const CrossSolidIcon = createFontello('\uE837');
export const DiningIcon = createFontello('\uE87E');
export const DollarIcon = createFontello('\uE801');
export const DownloadsIcon = createFontello('\uE871');
export const DutyFreeIcon = createFontello('\uE814');
export const EditIcon = createFontello('\uE897');
export const EmailIcon = createFontello('\uE89C');
export const EmployedIcon = createFontello('\uE896');
export const ExclamationMarkIcon = createFontello('\uE81A');
export const FacebookIcon = createFontello('\uE845');
export const FilterIcon = createFontello('\uE804');
export const FilterQuickIcon = createFontello('\uE8AD');
export const FinancialToolIcon = createFontello('\uE83C');
export const GiftIcon = createFontello('\uE816');
export const GlobalPassportIcon = createFontello('\uE89D');
export const GlobeIcon = createFontello('\uE8AE');
export const GoogleIcon = createFontello('\uE840');
export const GooglePlusIcon = createFontello('\uE88C');
export const GroupIcon = createFontello('\uE80A');
export const HamburgerIcon = createFontello('\uE87C');
export const HeadphonesIcon = createFontello('\uE81B');
export const HealthIcon = createFontello('\uE863');
export const HeartIcon = createFontello('\uE815');
export const HeartOutlinedIcon = createFontello('\uE835');
export const HiddenIcon = createFontello('\uE86E');
export const HiddenSmallIcon = createFontello('\uE86A');
export const HomeContentsIcon = createFontello('\uE810');
export const HouseIcon = createFontello('\uE888');
export const InfoIcon = createFontello('\uE851');
export const InformationOutlinedIcon = createFontello('\uE809');
export const InstagramIcon = createFontello('\uE88D');
export const InsuranceIcon = createFontello('\uE807');
export const InternetIcon = createFontello('\uE803');
export const InvestmentIcon = createFontello('\uE802');
export const KeyIcon = createFontello('\uE808');
export const LandlinePhoneIcon = createFontello('\uE812');
export const LineIcon = createFontello('\uE81C');
export const LinkedinIcon = createFontello('\uE88E');
export const LockIcon = createFontello('\uE884');
export const LostPhoneIcon = createFontello('\uE88B');
export const MinusIcon = createFontello('\uE81D');
export const NewIcon = createFontello('\uE80E');
export const NewPhoneIcon = createFontello('\uE88F');
export const NotificationIcon = createFontello('\uE818');
export const OctopusIcon = createFontello('\uE88A');
export const OfficeIcon = createFontello('\uE880');
export const OnlineShoppingIcon = createFontello('\uE806');
export const PartnershipsIcon = createFontello('\uE85E');
export const PassportIcon = createFontello('\uE853');
export const PassportsIcon = createFontello('\uE855');
export const PayrollIcon = createFontello('\uE805');
export const PersonalLoanIcon = createFontello('\uE813');
export const PetInsuranceIcon = createFontello('\uE894');
export const PinIcon = createFontello('\uE80B');
export const PinterestIcon = createFontello('\uE842');
export const PlusIcon = createFontello('\uE84F');
export const ProductIcon = createFontello('\uE895');
export const PromotionIcon = createFontello('\uE80D');
export const QuestionIcon = createFontello('\uE866');
export const QuotesIcon = createFontello('\uE823');
export const RetiredIcon = createFontello('\uE867');
export const RewardIcon = createFontello('\uE8A0');
export const SavingsIcon = createFontello('\uE882');
export const SearchIcon = createFontello('\uE800');
export const SecurityAccountIcon = createFontello('\uE84A');
export const SelfEmployedIcon = createFontello('\uE8A2');
export const ShareIcon = createFontello('\uE885');
export const ShoppingIcon = createFontello('\uE872');
export const StarIcon = createFontello('\uE83B');
export const StarOutlinedIcon = createFontello('\uE873');
export const StudentIcon = createFontello('\uE887');
export const TerrorismIcon = createFontello('\uE87B');
export const TickIcon = createFontello('\uE85A');
export const TickOutlinedIcon = createFontello('\uE864');
export const TickSmallIcon = createFontello('\uE861');
export const TickSolidIcon = createFontello('\uE84C');
export const TravelIcon = createFontello('\uE811');
export const TwitterIcon = createFontello('\uE82C');
export const UploadIcon = createFontello('\uE822');
export const UserOutlinedIcon = createFontello('\uE83D');
export const UserSolidIcon = createFontello('\uE8A1');
export const ValueIcon = createFontello('\uE883');
export const VisibleIcon = createFontello('\uE86B');
export const VisibleSmallIcon = createFontello('\uE862');
export const WarningErrorOutlinedIcon = createFontello('\uE87F');
export const WarningErrorSolidIcon = createFontello('\uE824');
export const WatersportsIcon = createFontello('\uE849');
export const WomanIcon = createFontello('\uE87D');
export const YoutubeIcon = createFontello('\uE838');

export { TikTokIcon } from '@hyphengroup/cms-components/components/icons/TikTokIcon';

if (process.env.NODE_ENV === 'development') {
  ActionsIcon.displayName = 'ActionsIcon';
  AirMilesIcon.displayName = 'AirMilesIcon';
  AmateurSportIcon.displayName = 'AmateurSportIcon';
  ArrowDownIcon.displayName = 'ArrowDownIcon';
  ArrowLeftIcon.displayName = 'ArrowLeftIcon';
  ArrowRightIcon.displayName = 'ArrowRightIcon';
  ArrowUpIcon.displayName = 'ArrowUpIcon';
  BatteryIcon.displayName = 'BatteryIcon';
  BookmarkOutlinedIcon.displayName = 'BookmarkOutlinedIcon';
  BookmarkSolidIcon.displayName = 'BookmarkSolidIcon';
  BrokenPhoneIcon.displayName = 'BrokenPhoneIcon';
  BurglaryIcon.displayName = 'BurglaryIcon';
  CalculatorIcon.displayName = 'CalculatorIcon';
  CalendarIcon.displayName = 'CalendarIcon';
  CalendarWithDatesIcon.displayName = 'CalendarWithDatesIcon';
  CarIcon.displayName = 'CarIcon';
  CashIcon.displayName = 'CashIcon';
  CashbackIcon.displayName = 'CashbackIcon';
  ChequeIcon.displayName = 'ChequeIcon';
  ChevronDownIcon.displayName = 'ChevronDownIcon';
  ChevronLeftIcon.displayName = 'ChevronLeftIcon';
  ChevronRightIcon.displayName = 'ChevronRightIcon';
  ChevronSmallDownIcon.displayName = 'ChevronSmallDownIcon';
  ChevronSmallLeftIcon.displayName = 'ChevronSmallLeftIcon';
  ChevronSmallRightIcon.displayName = 'ChevronSmallRightIcon';
  ChevronSmallUpIcon.displayName = 'ChevronSmallUpIcon';
  ChevronUpIcon.displayName = 'ChevronUpIcon';
  CircleIcon.displayName = 'CircleIcon';
  ClaimIcon.displayName = 'ClaimIcon';
  ClappingIcon.displayName = 'ClappingIcon';
  ClockIcon.displayName = 'ClockIcon';
  CodingIcon.displayName = 'CodingIcon';
  CollectIcon.displayName = 'CollectIcon';
  ConnectedIcon.displayName = 'ConnectedIcon';
  CopyLinkIcon.displayName = 'CopyLinkIcon';
  CreditCardIcon.displayName = 'CreditCardIcon';
  CreditCardsIcon.displayName = 'CreditCardsIcon';
  CrossIcon.displayName = 'CrossIcon';
  CrossOutlinedIcon.displayName = 'CrossOutlinedIcon';
  CrossSolidIcon.displayName = 'CrossSolidIcon';
  DiningIcon.displayName = 'DiningIcon';
  DollarIcon.displayName = 'DollarIcon';
  DownloadsIcon.displayName = 'DownloadsIcon';
  DutyFreeIcon.displayName = 'DutyFreeIcon';
  EditIcon.displayName = 'EditIcon';
  EmailIcon.displayName = 'EmailIcon';
  EmployedIcon.displayName = 'EmployedIcon';
  ExclamationMarkIcon.displayName = 'ExclamationMarkIcon';
  FacebookIcon.displayName = 'FacebookIcon';
  FilterIcon.displayName = 'FilterIcon';
  FilterQuickIcon.displayName = 'FilterQuickIcon';
  FinancialToolIcon.displayName = 'FinancialToolIcon';
  GiftIcon.displayName = 'GiftIcon';
  GlobalPassportIcon.displayName = 'GlobalPassportIcon';
  GlobeIcon.displayName = 'GlobeIcon';
  GoogleIcon.displayName = 'GoogleIcon';
  GooglePlusIcon.displayName = 'GooglePlusIcon';
  GroupIcon.displayName = 'GroupIcon';
  HamburgerIcon.displayName = 'HamburgerIcon';
  HeadphonesIcon.displayName = 'HeadphonesIcon';
  HealthIcon.displayName = 'HealthIcon';
  HeartIcon.displayName = 'HeartIcon';
  HeartOutlinedIcon.displayName = 'HeartOutlinedIcon';
  HiddenIcon.displayName = 'HiddenIcon';
  HiddenSmallIcon.displayName = 'HiddenSmallIcon';
  HomeContentsIcon.displayName = 'HomeContentsIcon';
  HouseIcon.displayName = 'HouseIcon';
  InfoIcon.displayName = 'InfoIcon';
  InformationOutlinedIcon.displayName = 'InformationOutlinedIcon';
  InstagramIcon.displayName = 'InstagramIcon';
  InsuranceIcon.displayName = 'InsuranceIcon';
  InternetIcon.displayName = 'InternetIcon';
  InvestmentIcon.displayName = 'InvestmentIcon';
  KeyIcon.displayName = 'KeyIcon';
  LandlinePhoneIcon.displayName = 'LandlinePhoneIcon';
  LineIcon.displayName = 'LineIcon';
  LinkedinIcon.displayName = 'LinkedinIcon';
  LockIcon.displayName = 'LockIcon';
  LostPhoneIcon.displayName = 'LostPhoneIcon';
  MinusIcon.displayName = 'MinusIcon';
  NewIcon.displayName = 'NewIcon';
  NewPhoneIcon.displayName = 'NewPhoneIcon';
  NotificationIcon.displayName = 'NotificationIcon';
  OctopusIcon.displayName = 'OctopusIcon';
  OfficeIcon.displayName = 'OfficeIcon';
  OnlineShoppingIcon.displayName = 'OnlineShoppingIcon';
  PartnershipsIcon.displayName = 'PartnershipsIcon';
  PassportIcon.displayName = 'PassportIcon';
  PassportsIcon.displayName = 'PassportsIcon';
  PayrollIcon.displayName = 'PayrollIcon';
  PersonalLoanIcon.displayName = 'PersonalLoanIcon';
  PetInsuranceIcon.displayName = 'PetInsuranceIcon';
  PinIcon.displayName = 'PinIcon';
  PinterestIcon.displayName = 'PinterestIcon';
  PlusIcon.displayName = 'PlusIcon';
  ProductIcon.displayName = 'ProductIcon';
  PromotionIcon.displayName = 'PromotionIcon';
  QuestionIcon.displayName = 'QuestionIcon';
  QuotesIcon.displayName = 'QuotesIcon';
  RetiredIcon.displayName = 'RetiredIcon';
  RewardIcon.displayName = 'RewardIcon';
  SavingsIcon.displayName = 'SavingsIcon';
  SearchIcon.displayName = 'SearchIcon';
  SecurityAccountIcon.displayName = 'SecurityAccountIcon';
  SelfEmployedIcon.displayName = 'SelfEmployedIcon';
  ShareIcon.displayName = 'ShareIcon';
  ShoppingIcon.displayName = 'ShoppingIcon';
  StarIcon.displayName = 'StarIcon';
  StarOutlinedIcon.displayName = 'StarOutlinedIcon';
  StudentIcon.displayName = 'StudentIcon';
  TerrorismIcon.displayName = 'TerrorismIcon';
  TickIcon.displayName = 'TickIcon';
  TickOutlinedIcon.displayName = 'TickOutlinedIcon';
  TickSmallIcon.displayName = 'TickSmallIcon';
  TickSolidIcon.displayName = 'TickSolidIcon';
  TravelIcon.displayName = 'TravelIcon';
  TwitterIcon.displayName = 'TwitterIcon';
  UploadIcon.displayName = 'UploadIcon';
  UserOutlinedIcon.displayName = 'UserOutlinedIcon';
  UserSolidIcon.displayName = 'UserSolidIcon';
  ValueIcon.displayName = 'ValueIcon';
  VisibleIcon.displayName = 'VisibleIcon';
  VisibleSmallIcon.displayName = 'VisibleSmallIcon';
  WarningErrorOutlinedIcon.displayName = 'WarningErrorOutlinedIcon';
  WarningErrorSolidIcon.displayName = 'WarningErrorSolidIcon';
  WatersportsIcon.displayName = 'WatersportsIcon';
  WomanIcon.displayName = 'WomanIcon';
  YoutubeIcon.displayName = 'YoutubeIcon';
}
